<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        {{title}}
        <i class="fa fa-times-circle pull-right" (click)="closeDialog('-1')" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content style="overflow: hidden;">
    <div class="d-flex justify-content-center eip-pt-10 eip-pb-10">
        <div class="title-container d-flex align-items-left">
            <p>Document No : {{documentNo}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-center eip-pt-10 eip-pb-10">
        <div class="title-container d-flex align-items-left">
            <p style="font-weight: 1000;">Next Step : {{nextStepDescription}}</p>
        </div>
    </div>
    <div class="row justify-content-center" *ngFor="let roleMem of roleMembers">
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <EIPMultiSelectAutoComplete [dataSource]="roleMem.roleMembers" ShowTextValueField='N'
                [setId]="roleMem.roleId" [WaterMarkText]="roleMem.roleDescription" TextField="memberName"
                ValueField="memberId" [defaultSelectedValues]="roleMem.selectedMemberIds"
                (valueChange)="onChange_Member($event,roleMem.roleId)">
            </EIPMultiSelectAutoComplete>
        </div>
    </div>
    <div class="row justify-content-center" *ngFor="let mem of members">
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <EIPMultiSelectAutoComplete [dataSource]="mem.Members" ShowTextValueField='N'
                [setId]="mem" [WaterMarkText]="mem.Description" TextField="member_Name"
                ValueField="member_Id" [defaultSelectedValues]="mem.selectedMembersIds"
                (valueChange)="onChange_Members($event)">
            </EIPMultiSelectAutoComplete>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <div style="display: flex;justify-content: center;">
        <div class="notification">
            <p style="margin-left: 2%;font-style: italic;"><strong>Note </strong>
                <br>
                * Reassignment is applicable only for members whose action is yet pending.
                <br>
                * Click "Re-Assign & Proceed" button only if any member assigned is modified; otherwise, close the tab.
                <br>
            </p>
        </div>
    </div>
    <div class="row justify-content-end flex-grow-1">
        <button type="button" class="btn btn-primary" (click)="changeUser()" id="btnEDMSave" [disabled]="disable" ><i class="fa fa-delegated-access" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Re-Assign & Proceed</button>
        <button (click)="closeDialog('-1')" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-times-circle" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Close</button>
    </div>
</div>